import { Money, NoCrash, PermIdentity } from "@mui/icons-material";
import { PricingRequest, UserRole } from "system/Domain";
import LayoutNavigationItem from "../Components/Layout/LayoutNavigationItem";
import LayoutNavigationSection from "../Components/Layout/LayoutNavigationSection";

interface Props {
	request: PricingRequest;
	vehicleId?: string;
	assessmentId?: string;
}

export default ({ request, vehicleId, assessmentId }: Props) => {
	return (
		<LayoutNavigationSection title={`Kaufpreisanfrage ${request.plateNumber}`}>
			<LayoutNavigationItem
				roles={[UserRole.AldUser]}
				icon={<Money />}
				title="Kaufpreisanfrage"
				path={`/sales/pricing-requests/${request.id}`}
			/>

			{!!vehicleId && !!assessmentId && (
				<LayoutNavigationItem
					roles={[UserRole.LotManager, UserRole.AldUser]}
					icon={<NoCrash />}
					title="Gutachten"
					path={`/vehicles/${vehicleId}/assessments/${assessmentId}`}
				/>
			)}

			{!!request.customerOrderId && (
				<LayoutNavigationItem
					roles={[UserRole.AldUser]}
					icon={<PermIdentity />}
					title="Kundenauftrag"
					path={`/orders/customers/${request.customerOrderId}`}
				/>
			)}
		</LayoutNavigationSection>
	);
};
